import React from 'react';
import { getAttachmentCategory } from './attachmentUtils';
import { ImageAttachment } from './ImageAttachment';
import { VideoAttachment } from './VideoAttachment';
import { AudioAttachment } from './AudioAttachment';
import { PdfAttachment } from './PdfAttachment';
import { DocumentAttachment } from './DocumentAttachment';
import { GenericFileAttachment } from './GenericFileAttachment';

export interface AttachmentRendererProps {
  fileName: string;
  url: string;
  fileSize?: number | undefined;
  fileType?: string | undefined;
  workspaceId?: string | undefined;
  fileId?: string | undefined;
}

export const AttachmentRenderer: React.FC<AttachmentRendererProps> = ({
  fileName,
  url,
  fileSize,
  fileType,
  workspaceId: propWorkspaceId,
  fileId: propFileId,
}) => {
  if (!url || !fileName) return null;

  // Extract workspaceId & fileId from download URL if not provided directly
  let workspaceId = propWorkspaceId;
  let fileId = propFileId;

  if (!workspaceId || !fileId) {
    const match = url.match(/\/workspaces\/([0-9a-fA-F-]{36})\/files\/([0-9a-fA-F-]{36})/);
    if (match && match[1] && match[2]) {
      workspaceId = match[1];
      fileId = match[2];
    }
  }

  const category = getAttachmentCategory(fileName, fileType);

  switch (category) {
    case 'IMAGE':
      return (
        <ImageAttachment
          fileName={fileName}
          url={url}
          fileSize={fileSize}
          workspaceId={workspaceId}
          fileId={fileId}
        />
      );

    case 'VIDEO':
      return (
        <VideoAttachment
          fileName={fileName}
          url={url}
          fileSize={fileSize}
          workspaceId={workspaceId}
          fileId={fileId}
        />
      );

    case 'AUDIO':
      return (
        <AudioAttachment
          fileName={fileName}
          url={url}
          fileSize={fileSize}
          workspaceId={workspaceId}
          fileId={fileId}
        />
      );

    case 'PDF':
      return (
        <PdfAttachment
          fileName={fileName}
          url={url}
          fileSize={fileSize}
          workspaceId={workspaceId}
          fileId={fileId}
        />
      );

    case 'DOCUMENT':
    case 'SPREADSHEET':
    case 'PRESENTATION':
    case 'ARCHIVE':
      return (
        <DocumentAttachment
          fileName={fileName}
          url={url}
          category={category}
          fileSize={fileSize}
          workspaceId={workspaceId}
          fileId={fileId}
        />
      );

    case 'GENERIC':
    default:
      return (
        <GenericFileAttachment
          fileName={fileName}
          url={url}
          fileSize={fileSize}
          workspaceId={workspaceId}
          fileId={fileId}
        />
      );
  }
};
